import type { CityConfig } from "../city-template/types";

export const lelandConfig: CityConfig = {
  city: "Leland",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "leland",
  route: "/cities/leland",
  title: "Emergency Passport Leland, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Leland, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Brunswick County and the Wilmington metro area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Leland, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Leland and Brunswick County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Leland%20North%20Carolina%20scenic%20coastal%20community%20at%20golden%20hour%20with%20Cape%20Fear%20River%20views%2C%20modern%20suburban%20neighborhoods%20and%20waterfront%20homes%20along%20the%20Intracoastal%20Waterway%2C%20warm%20sunset%20light%20over%20Brunswick%20County%20marshlands%20and%20live%20oak%20trees%2C%20peaceful%20coastal%20atmosphere%20with%20natural%20beauty%2C%20professional%20landscape%20photography%20with%20warm%20earthy%20tones%20and%20soft%20coastal%20lighting%2C%20no%20text%20or%20signs%20on%20buildings%2C%20clean%20modern%20coastal%20scene&width=1800&height=700&seq=leland-hero-nc-001&orientation=landscape",
  heroImageAlt: "Leland North Carolina scenic coastal community along the Cape Fear River at golden hour",
  geoPosition: "34.2563;-78.0447",
  geoPlacename: "Leland, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 370 miles north of Leland — about 6 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Leland", zips: "28451" },
    { name: "Wilmington", zips: "28401–28412" },
    { name: "Carolina Beach", zips: "28428" },
    { name: "Wrightsville Beach", zips: "28480" },
    { name: "Hampstead", zips: "28443" },
    { name: "Southport", zips: "28461, 28465" },
    { name: "Kure Beach", zips: "28449" },
    { name: "Castle Hayne", zips: "28429" },
    { name: "Ogden", zips: "28411" },
    { name: "Boiling Spring Lakes", zips: "28461" },
    { name: "Belville", zips: "28451" },
    { name: "Navassa", zips: "28451" },
    { name: "Oak Island", zips: "28461, 28465" },
    { name: "Holden Beach", zips: "28462" },
    { name: "Ocean Isle Beach", zips: "28469" },
    { name: "Sunset Beach", zips: "28468" },
    { name: "Calabash", zips: "28467" },
    { name: "Shallotte", zips: "28459, 28470" },
    { name: "Supply", zips: "28462" },
    { name: "Bolivia", zips: "28422" },
    { name: "St. James", zips: "28461" },
    { name: "Myrtle Beach", zips: "29572, 29577, 29578, 29579, 29588" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Brunswick County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Brunswick County Coverage", desc: "Serving Leland, Southport, Oak Island, and the Wilmington metro" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Wilmington, NC", route: "/cities/wilmington" },
    { name: "Fast passport renewal in Myrtle Beach, SC", route: "/" },
    { name: "Emergency passport help in Southport, NC", route: "/" },
    { name: "Urgent passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Same-day passport help in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Passport courier services in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Passport courier services in New Bern, NC", route: "/cities/new-bern" },
    { name: "Fast passport renewal in Fayetteville, NC", route: "/cities/fayetteville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Leland remotely via secure courier. We do not have a walk-in office in Leland — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Brunswick County and the Wilmington metro travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Brunswick County and the Wilmington metropolitan area including New Hanover and Pender counties",
  serviceAreaIntro: "From the quiet neighborhoods of Leland to the bustling waterfront of Wilmington, from the beach communities of Carolina Beach and Wrightsville Beach to the coastal towns of Southport and Oak Island, from the golf communities of St. James and Calabash to the resort areas of Ocean Isle Beach and Sunset Beach, from the inland communities of Shallotte and Supply to the Grand Strand of Myrtle Beach — Fast Passport Center serves the entire Leland region. We regularly help travelers from Brunswick County, the Cape Fear Coast, and the northern South Carolina coast get their passports fast.",
  nearbyCitiesIntro: "We serve all Leland neighborhoods and the surrounding Brunswick County and Cape Fear Coast area including Wilmington, Carolina Beach, Wrightsville Beach, Hampstead, Southport, Kure Beach, Oak Island, Holden Beach, Ocean Isle Beach, Sunset Beach, Calabash, Shallotte, Supply, Boiling Spring Lakes, Belville, Navassa, Castle Hayne, and Myrtle Beach. If you are anywhere in Brunswick County, New Hanover County, Pender County, or the northern South Carolina coast, we have you covered.",
  howItWorksIntro: "Most Leland travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Leland travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Leland and Brunswick County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Leland? Here are the most common ones we hear from Brunswick County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Leland international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Leland, NC",
      rating: 5,
      text: "My passport expired the week before our honeymoon cruise to the Caribbean. Fast Passport Center had my renewal in 3 days. Never had to leave Brunswick County. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "Mark D.",
      location: "Southport, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in London. Got it in 30 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. True lifesavers.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah K.",
      location: "Oak Island, NC",
      rating: 5,
      text: "Business trip to Mexico came up with 4 days notice. They got me a passport in 3 business days. The communication was outstanding throughout the process.",
      service: "Emergency Passport",
    },
    {
      name: "Robert T.",
      location: "Carolina Beach, NC",
      rating: 5,
      text: "First passport for my son before his surf trip to Costa Rica. Fast Passport Center helped us navigate every step. Ready in 5 days with zero stress.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "leland-1",
      name: "Leland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1121 Village Rd NE",
      city: "Leland",
      state: "NC",
      zip: "28451",
      phone: "(910) 383-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Leland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Leland facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "leland-2",
      name: "Wilmington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "251 N Front St",
      city: "Wilmington",
      state: "NC",
      zip: "28401",
      phone: "(910) 341-6211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles east of Leland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for New Hanover County. Full passport services available. High volume — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "leland-3",
      name: "Southport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "102 W Brown St",
      city: "Southport",
      state: "NC",
      zip: "28461",
      phone: "(910) 457-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Leland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Southport, Oak Island, and Boiling Spring Lakes. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "leland-4",
      name: "Shallotte Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4636 Main St",
      city: "Shallotte",
      state: "NC",
      zip: "28470",
      phone: "(910) 754-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southwest of Leland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Shallotte and west Brunswick County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "leland-5",
      name: "Brunswick County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "310 Government Center Dr NE",
      city: "Bolivia",
      state: "NC",
      zip: "28422",
      phone: "(910) 253-3900",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Brunswick County Courthouse, Bolivia",
      website: "https://www.brunswickcountync.gov/",
      websiteLabel: "Brunswick County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "leland-6",
      name: "Carolina Beach Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1101 N Lake Park Blvd",
      city: "Carolina Beach",
      state: "NC",
      zip: "28428",
      phone: "(910) 458-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles southeast of Leland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Carolina Beach and Kure Beach area. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Leland photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Brunswick County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Leland applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Brunswick County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Leland travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Leland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Leland address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Leland before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Leland for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Leland?", a: "Fast Passport Center offers fast passport renewal in Leland in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Leland?", a: "The nearest regional passport agency to Leland is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 370 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Leland without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Leland?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 6 hours from Leland — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Brunswick County residents." },
    { q: "Do you serve the beach communities near Leland?", a: "Absolutely. Fast Passport Center serves all of the Cape Fear Coast and Brunswick County beach communities including Leland, Wilmington, Carolina Beach, Wrightsville Beach, Kure Beach, Southport, Oak Island, Holden Beach, Ocean Isle Beach, Sunset Beach, Hampstead, and Boiling Spring Lakes. Our courier service works seamlessly from any address in Brunswick, New Hanover, or Pender counties." },
    { q: "Can I expedite a child passport in Leland?", a: "Yes. Fast Passport Center expedites child passports in Leland for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Brunswick County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Leland with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Leland", address: "1120 Village Rd NE, Leland, NC 28451", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Leland", address: "108 Village Rd NE, Leland, NC 28451", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Leland", address: "108 Village Rd NE, Leland, NC 28451", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Wilmington", address: "1900 S 17th St, Wilmington, NC 28401", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Southport", address: "1650 N Howe St, Southport, NC 28461", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Shallotte", address: "4630 Main St, Shallotte, NC 28470", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Carolina Beach", address: "1101 N Lake Park Blvd, Carolina Beach, NC 28428", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Wilmington", address: "1520 S 17th St, Wilmington, NC 28401", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Leland",
      address: "1200 Magnolia Village Way, Leland, NC 28451",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Wilmington",
      address: "2390 Carolina Beach Rd, Wilmington, NC 28401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Southport",
      address: "1061 N Howe St, Southport, NC 28461",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Brunswick County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Shallotte",
      address: "1620 Bricklanding Rd, Shallotte, NC 28470",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves west Brunswick County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ILM",
      name: "Wilmington International Airport",
      distance: "15 miles northeast of Leland",
      address: "1740 Airport Blvd, Wilmington, NC 28405",
      note: "Primary airport for the Cape Fear Coast. Direct flights to major domestic hubs including New York, Atlanta, and Charlotte. Seasonal international connections. Only 20 minutes from Leland.",
      flightUrl: "https://www.flyilm.com/",
      flightLabel: "ILM Airport",
      featured: true,
    },
    {
      code: "MYR",
      name: "Myrtle Beach International Airport",
      distance: "65 miles southwest of Leland",
      address: "1187 Jetport Rd, Myrtle Beach, SC 29577",
      note: "Alternative airport for South Carolina coastal residents. Direct flights to major domestic hubs and seasonal international routes.",
      flightUrl: "https://www.flymyrtlebeach.com/",
      flightLabel: "MYR Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "130 miles north of Leland",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel from Brunswick County.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Brunswick County Register of Deeds", url: "https://www.brunswickcountync.gov/rod/", description: "Birth, death, and marriage records for Brunswick County" },
    { name: "Brunswick County Superior Court", url: "https://www.nccourts.gov/locations/brunswick-county", description: "Divorce records and court documents for Brunswick County" },
  ],
};